export default "__VITE_ASSET__D6ALxX3V__"